import { SortDescriptor } from "react-aria-components";

import { IdpGroupFilterItemKeys } from "../../constants";
import { ManagedUserGroupView } from "../../types";
import { IDP_GROUP_COLUMN_ID, SORT_CONFIG } from "../constants";

export const sortGroups = (
  groups: ManagedUserGroupView[],
  sortDescriptor: SortDescriptor
): ManagedUserGroupView[] => {
  const itemKey = SORT_CONFIG[
    sortDescriptor.column as IDP_GROUP_COLUMN_ID
  ] as IdpGroupFilterItemKeys;

  // If no sort key or direction is provided, or if sort key is invalid, return unsorted copy
  if (
    !sortDescriptor.column ||
    !sortDescriptor.direction ||
    !Object.values(IdpGroupFilterItemKeys).includes(itemKey)
  ) {
    return [...groups];
  }

  const sortedGroups = [...groups];

  return sortedGroups.sort((a, b) => {
    let aValue, bValue;

    switch (itemKey) {
      case IdpGroupFilterItemKeys.GroupId:
        aValue = a.groupName;
        bValue = b.groupName;
        break;
      case IdpGroupFilterItemKeys.Users:
        aValue = a.memberCount;
        bValue = b.memberCount;
        break;
      case IdpGroupFilterItemKeys.LastLogin:
        aValue = a.lastLoginTime;
        bValue = b.lastLoginTime;
        break;
      case IdpGroupFilterItemKeys.IdentityProvider:
        aValue = a.identityProvider;
        bValue = b.identityProvider;
        break;
      case IdpGroupFilterItemKeys.Status:
        aValue = a.status;
        bValue = b.status;
        break;
      default:
        // This case should never be reached due to the validation at the beginning
        // But just in case, return a copy of the unsorted array
        return 0;
    }

    // null values should always come last
    if (aValue === null && bValue === null) {
      return 0; // Both null, consider equal
    }
    if (aValue === null) {
      return 1; // a is null, should be placed after b
    }
    if (bValue === null) {
      return -1; // b is null, should be placed after a
    }

    // Sort based on direction for other fields
    if (sortDescriptor.direction === "ascending") {
      if (typeof aValue === "string" && typeof bValue === "string") {
        return aValue.localeCompare(bValue);
      }
      return aValue > bValue ? 1 : -1;
    } else {
      if (typeof aValue === "string" && typeof bValue === "string") {
        return bValue.localeCompare(aValue);
      }
      return bValue > aValue ? 1 : -1;
    }
  });
};
